import { z } from 'zod'
const jsonObject = z.record(z.unknown())
export const adminAuthSessionResponseSchema = jsonObject
export const adminAuthLogoutResponseSchema = jsonObject
export type AdminAuthSessionResponse = z.infer<typeof adminAuthSessionResponseSchema>
export type AdminAuthLogoutResponse = z.infer<typeof adminAuthLogoutResponseSchema>
